import { EVENT_TICKET_PREVIEW_LABELS } from '@modules/dashboard/components/event-ticket-preview/event-ticket-preview.constant';
import { MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE } from '@modules/whitelabel-cover-page/marketing-page-section/marketing-page-section.constants';

export const EVENT_TICKETS_BANNER_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'event-tickets-banner-layout',
  LAYOUT_LABEL: 'Event Tickets Banner Layout',
  LAYOUT_IMAGE_PATH: 'https://cdn-www.topfans.com/TopFans/1786017372136.png',
  LAYOUT_DESCRIPTION:
    'Full-width banner with event ticket list overlay and buy buttons',
  DEFAULT_ALT_IMAGE: 'Banner background',
  DEFAULT_BUY_TICKETS_CTA: EVENT_TICKET_PREVIEW_LABELS.BUY_TICKETS,
  HEADING_POSITION_LEFT: 'left',
  HEADING_POSITION_RIGHT: 'right',
  INFO_HEADING_HIGHLIGHT: MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE,
  labels: {
    TITLE: 'Title',
    SECTION_HEADING: 'Heading',
    SUBHEADING: 'Subheading',
    BACKGROUND_IMAGE: 'Background Image',
    TICKET_CTA_TEXT: 'Ticket Button Label',
    HEADING_POSITION: 'Show Heading on',
    HEADING_POSITION_LEFT: 'Left',
    HEADING_POSITION_RIGHT: 'Right',
    EVENT_TICKETS: 'Event Tickets'
  },
  placeholders: {
    TITLE: 'Enter title',
    SECTION_HEADING: 'Enter heading',
    SUBHEADING: 'Enter subheading',
    TICKET_CTA_TEXT: 'e.g. Buy Tickets'
  },
  DATA_KEYS: {
    SECTION_TITLE: 'section_title',
    SECTION_HEADING: 'section_heading',
    SUBHEADING: 'subheading',
    BACKGROUND_IMAGE: 'background_image',
    HEADING_POSITION: 'heading_position',
    HEADING_FONT_SIZE: 'heading_font_size',
    TICKET_CTA_TEXT: 'ticket_cta_text',
    EVENT_TICKETS: 'event_tickets'
  }
} as const;
